import { renovation_category_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateRenovationCategoryEnum = (enumValue: renovation_category_enum) => {
  switch (enumValue) {
    case renovation_category_enum.CUSTOM:
      return <Trans i18nKey="Enum_RenovationCategoryEnum-CUSTOM" />;
    case renovation_category_enum.ENERGY_SOURCE:
      return <Trans i18nKey="Enum_RenovationCategoryEnum-ENERGY_SOURCE" />;
    case renovation_category_enum.ENVELOPE:
      return <Trans i18nKey="Enum_RenovationCategoryEnum-ENVELOPE" />;
    case renovation_category_enum.TECHNOLOGY:
      return <Trans i18nKey="Enum_RenovationCategoryEnum-TECHNOLOGY" />;
  }
};

export const translateRenovationCategoryEnum_dynamic = (enumValue: renovation_category_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case renovation_category_enum.CUSTOM:
      return t('Enum_RenovationCategoryEnum-CUSTOM');
    case renovation_category_enum.ENERGY_SOURCE:
      return t('Enum_RenovationCategoryEnum-ENERGY_SOURCE');
    case renovation_category_enum.ENVELOPE:
      return t('Enum_RenovationCategoryEnum-ENVELOPE');
    case renovation_category_enum.TECHNOLOGY:
      return t('Enum_RenovationCategoryEnum-TECHNOLOGY');
  }
};
